import React from 'react';
import { Grid } from '@mui/material';
import { ResponseItem, Label, ResponseRange } from '../modules.interface';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';
import { SelectInput } from '../../../../../../components/select/selectInput';
import { Checkbox } from '../../../../../../components/checkBox/checkBox';

export interface SelectQuestionsProps {
  options: ResponseItem[] | ResponseRange[] | Label[];
  data: any;
  onSave: (
    selectionKey: string,
    selectionValue: string,
    notTestedKey: string,
  ) => void;
  onSaveNotTested: (
    notTestedKey: string,
    notTestedValue: boolean,
    selectionKey?: string,
  ) => void;
}
export function SelectQuestions({
  options,
  data,
  onSave,
  onSaveNotTested,
}: SelectQuestionsProps) {
  const { t } = useCustomTranslation('assessment');

  return (
    <>
      {options.map((item: any) => {
        return (
          <Grid key={item.key} sx={{ mt: 2 }}>
            <SelectInput
              label={t(item.label)}
              name={item.label}
              items={item.items.map((_item: any) => {
                return { ..._item, value: _item.value, text: t(_item.text) };
              })}
              onChange={(event: any) =>
                onSave(item.key, event.target.value, item.notTestedKey)
              }
              fullWidth
              defaultValue={data[item.key]}
              tabIndex={0}
            />
            <Checkbox
              label={t('ID_GLASGOW_COMA_SCALE_UNABLE_TO_COMPLETE_RESPONSE')}
              checked={data[item.notTestedKey]}
              size="small"
              onChange={(event: any) =>
                onSaveNotTested(
                  item.notTestedKey,
                  event.target.checked,
                  item.key,
                )
              }
              name={item.notTestedKey}
            />
          </Grid>
        );
      })}
    </>
  );
}
